import React, { useEffect, useState } from "react";
import axiosAuth from "../../api/axiosAuth";
import { API } from "../config";
import "../../style/matriculamasiva.css";
import * as XLSX from "xlsx";

export default function MatriculaMasiva() {
  const [file, setFile] = useState(null);

  const [sedes, setSedes] = useState([]);
  const [sedeId, setSedeId] = useState("");

  const [loading, setLoading] = useState(false);
  const [resultado, setResultado] = useState(null);

  useEffect(() => {
    cargarSedes();
  }, []);

  const cargarSedes = async () => {
    try {
      const res = await axiosAuth.get(
        `${API}/users/sedes`
      );

      setSedes(res.data || []);
    } catch (error) {
      console.error(error);
    }
  };

 const descargarPlantilla = () => {
  const datos = [
    {
      documento_estudiante: "",
      tipo_documento: "",
      nombres_estudiante: "",
      apellidos_estudiante: "",
      fecha_nacimiento: "",
      grado: "",
      grupo: "",

      documento_padre: "",
      nombres_padre: "",
      apellidos_padre: "",
      telefono_padre: "",
      email_padre: "",
      parentesco: "",
    },
  ];

  const worksheet =
    XLSX.utils.json_to_sheet(datos);

  worksheet["!cols"] = [
    { wch: 20 }, // documento_estudiante
    { wch: 18 }, // tipo_documento
    { wch: 30 }, // nombres_estudiante
    { wch: 30 }, // apellidos_estudiante
    { wch: 20 }, // fecha_nacimiento
    { wch: 12 }, // grado
    { wch: 12 }, // grupo

    { wch: 20 }, // documento_padre
    { wch: 30 }, // nombres_padre
    { wch: 30 }, // apellidos_padre
    { wch: 20 }, // telefono_padre
    { wch: 35 }, // email_padre
    { wch: 20 }, // parentesco
  ];

  const workbook =
    XLSX.utils.book_new();

  XLSX.utils.book_append_sheet(
    workbook,
    worksheet,
    "Matriculas"
  );

  const instrucciones = [
    [
      "IMPORTANTE"
    ],
    [
      "No cambie los nombres de las columnas."
    ],
    [
      "Puede copiar y pegar la información desde su Excel actual."
    ],
    [
      "Columnas obligatorias:"
    ],
    [
      "documento_estudiante"
    ],
    [
      "nombres_estudiante"
    ],
    [
      "apellidos_estudiante"
    ],
    [
      "grado"
    ],
    [
      "grupo"
    ],
    [
      ""
    ],
    [
      "Las demás columnas son opcionales."
    ]
  ];

  const sheetInstrucciones =
    XLSX.utils.aoa_to_sheet(
      instrucciones
    );

  sheetInstrucciones["!cols"] = [
    { wch: 80 }
  ];

  XLSX.utils.book_append_sheet(
    workbook,
    sheetInstrucciones,
    "Instrucciones"
  );

  XLSX.writeFile(
    workbook,
    "plantilla_matricula_masiva.xlsx"
  );
};

  const importar = async () => {
    try {
      if (!file) {
        return alert(
          "Seleccione un archivo Excel"
        );
      }

      setLoading(true);

      const formData =
        new FormData();

      formData.append(
        "excel",
        file
      );

      // Solo enviamos sede si fue seleccionada
      if (sedeId) {
        formData.append(
          "sede_id",
          sedeId
        );
      }

      const res =
        await axiosAuth.post(
          `${API}/matriculas-masivas/importar`,
          formData,
          {
            headers: {
              "Content-Type":
                "multipart/form-data",
            },
          }
        );

      setResultado(res.data);

      alert(
        `Importación finalizada. ${res.data.creados || 0} estudiantes creados`
      );
    } catch (error) {
      console.error(error);

      alert(
        error?.response?.data
          ?.message ||
          "Error importando matrículas"
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="matricula-masiva-container">
      <h2>
        📥 Matrícula Masiva
      </h2>

      {/* =======================================
          INSTRUCCIONES
      ======================================= */}
      <div className="card instrucciones-importacion">
        <h3>📌 Instrucciones</h3>

        <ol>
          <li>
            Descargue la plantilla oficial.
          </li>

          <li>
            No modifique los nombres
            de las columnas.
          </li>

          <li>
            Puede copiar y pegar los
            datos desde su Excel actual.
          </li>

          <li>
            Las columnas obligatorias
            son:
          </li>
        </ol>

        <div className="columnas-obligatorias">
          <code>
            documento_estudiante
          </code>

          <code>
            nombres_estudiante
          </code>

          <code>
            apellidos_estudiante
          </code>

          <code>grado</code>

          <code>grupo</code>
        </div>

        <div className="nota">

        <p>
          ✅ Las demás columnas son
          opcionales.
        </p>

        <p>
          ⚠️ Si los nombres de las
          columnas no coinciden con
          la plantilla, el sistema no
          podrá procesar correctamente
          la información.
        </p>

        <p>
          💡 Recomendación:
          descargue la plantilla oficial
          y copie los datos de su Excel
          actual dentro de ella antes de
          importar.
        </p>

        <p> 👉 Luego de haber matriculado 
          con exito , 
          vez al modulo de crear usuarios ,
          busca el documento del padre
           de familia 
          y actualiza su contraseña
           para que pueda 
          acceder al sistema y ver
           la información de su hijo o hija.
        </p>
        </div>
      </div>

      {/* =======================================
          PLANTILLA
      ======================================= */}
      <div className="card">
        <button
          className="btn-descargar"
          onClick={
            descargarPlantilla
          }
        >
          📄 Descargar Plantilla
        </button>
      </div>

      {/* =======================================
          IMPORTACIÓN
      ======================================= */}
      <div className="card">
        <label>
          Destino de la matrícula
        </label>

        <select
          value={sedeId}
          onChange={(e) =>
            setSedeId(
              e.target.value
            )
          }
        >
          <option value="">
            🏛️ Institución Principal
          </option>

          {sedes.map((sede) => (
            <option
              key={sede.id}
              value={sede.id}
            >
              🏫 {sede.nombre}
            </option>
          ))}
        </select>

        <small
          style={{
            marginTop: "8px",
            display: "block",
            color: "#666",
          }}
        >
          Si no selecciona una sede,
          los estudiantes quedarán
          matriculados directamente
          en la institución principal.
        </small>

        <input
          type="file"
          accept=".xlsx,.xls,.csv"
          onChange={(e) =>
            setFile(
              e.target.files?.[0]
            )
          }
        />

        {file && (
          <div className="archivo-seleccionado">
            📄 {file.name}
          </div>
        )}

        <button
          className="btn-importar"
          disabled={loading}
          onClick={importar}
        >
          {loading
            ? "⏳ Importando..."
            : "🚀 Importar Matrículas"}
        </button>
      </div>

      {/* =======================================
          RESULTADO
      ======================================= */}
      {resultado && (
        <div className="card">
          <h3>
            📊 Resultado de la
            Importación
          </h3>

          <div className="resultado-grid">
            <div className="resultado-item success">
              <h4>
                Matrículas creadas
              </h4>

              <span>
                {resultado.creados || 0}
              </span>
            </div>

            <div className="resultado-item error">
              <h4>Errores</h4>

              <span>
                {resultado.errores
                  ?.length || 0}
              </span>
            </div>
          </div>

          {resultado.errores
            ?.length > 0 && (
            <>
              <h4
                style={{
                  marginTop: "25px",
                }}
              >
                Registros con error
              </h4>

              <div className="table-wrapper">
                <table>
                  <thead>
                    <tr>
                      <th>
                        Documento
                      </th>
                      <th>
                        Error
                      </th>
                    </tr>
                  </thead>

                  <tbody>
                    {resultado.errores.map(
                      (
                        item,
                        index
                      ) => (
                        <tr
                          key={
                            index
                          }
                        >
                          <td>
                            {
                              item.documento
                            }
                          </td>

                          <td>
                            {
                              item.error
                            }
                          </td>
                        </tr>
                      )
                    )}
                  </tbody>
                </table>
              </div>
            </>
          )}
        </div>
      )}
    </div>
  );
}